import { registerUser } from "../../api/userInviteService";

export const useRegisterUser = (successCallback) => {
  const register = async (data) => {
    try {
      const newRecord = await registerUser(data);
      successCallback(newRecord);
      return newRecord;
    } catch (error) {
      console.error("Failed to register user:", error);
      throw error;
    }
  };
  return { register };
};